import { render, staticRenderFns } from "./AppFooterRegistration.vue?vue&type=template&id=4039a815&scoped=true&"
var script = {}
import style0 from "./AppFooterRegistration.vue?vue&type=style&index=0&id=4039a815&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4039a815",
  null
  
)

export default component.exports